import { Button, Container, ContainerFluid } from '../../components';
import MvpCard from './mvp-card';
import styles from './mvp-intro.module.css';
import commonStyles from './mvp.module.css';

export interface MVPIntroProps {
  buttonText?: string;
  buttonLink?: string;
}

export default function MVPIntro({
  buttonText = 'Start a project',
  buttonLink = '#contact',
}: MVPIntroProps) {
  return (
    <section>
      <ContainerFluid>
        <div className={styles.intro}>
          <Container>
            <div className={styles.wrapper}>
              <h1 className={commonStyles.h1}>
                BUILD YOUR <span className={styles.bold}>MVP</span> WITH <br />{' '}
                AI & CLAUDE CODE IN{' '}
                <span className={styles.bold}>6&nbsp;WEEKS</span>
              </h1>
              <div className={styles.box}>
                <MvpCard className={styles.card}>
                  <p className={styles.cardText}>
                    We build native iOS, Android, and Web apps for startups.
                  </p>
                  <br />
                  <p className={styles.cardText}>
                    With 40+ projects delivered, our{' '}
                    <span style={{ whiteSpace: 'nowrap' }}>
                      <b>AI</b>-powered
                    </span>{' '}
                    process helps launch <b>MVPs</b> in as little as{' '}
                    <b>6&nbsp;weeks</b> — without compromising quality.
                  </p>

                  {/*
                  <p className={styles.cardText}>
                    With 40+ projects delivered, we’ve developed a rapid process
                    to help you launch fast — without sacrificing quality.
                  </p> */}
                </MvpCard>
                <Button tag="a" href={buttonLink} appearance="primary">
                  {buttonText}
                </Button>
              </div>
            </div>
          </Container>
        </div>
      </ContainerFluid>
    </section>
  );
}
